import {
    ErrorWrapper,
    IfgGatewayIntegrationFile,
    OrderQueueOptions
} from '@trade-platform/ui-shared';
import { failure, inProgress, notAsked, RemoteData, success } from 'ngx-remotedata';
import { OrderAdminActions, OrderAdminActionTypes } from './actions';

export type OrderNigoToNeedsClarificationState = RemoteData<null, ErrorWrapper>;

export function orderNigoToNeedsClarificationReducer(
    state: OrderNigoToNeedsClarificationState = notAsked(),
    action: OrderAdminActions
): OrderNigoToNeedsClarificationState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_NIGO_TO_NEEDS_CLARIFICATION:
            return inProgress();
        case OrderAdminActionTypes.ORDER_NIGO_TO_NEEDS_CLARIFICATION_SUCCESS:
            return success(null);
        case OrderAdminActionTypes.ORDER_NIGO_TO_NEEDS_CLARIFICATION_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}

export type OrderToWetsignState = RemoteData<null, ErrorWrapper>;

export function orderToWetsignReducer(
    state: OrderToWetsignState = notAsked(),
    action: OrderAdminActions
): OrderToWetsignState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_TO_WETSIGN:
            return inProgress();
        case OrderAdminActionTypes.ORDER_TO_WETSIGN_SUCCESS:
            return success(null);
        case OrderAdminActionTypes.ORDER_TO_WETSIGN_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}

export type AdminMarkOrderCompleteState = RemoteData<null, ErrorWrapper>;

export function adminMarkOrderCompleteReducer(
    state: AdminMarkOrderCompleteState = notAsked(),
    action: OrderAdminActions
): AdminMarkOrderCompleteState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_MARK_COMPLETE:
            return inProgress();
        case OrderAdminActionTypes.ORDER_MARK_COMPLETE_SUCCESS:
            return success(null);
        case OrderAdminActionTypes.ORDER_MARK_COMPLETE_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}

export type AdminResubmitOrderState = RemoteData<null, ErrorWrapper>;

export function adminResubmitOrderReducer(
    state: AdminResubmitOrderState = notAsked(),
    action: OrderAdminActions
): AdminResubmitOrderState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_RESUBMIT:
            return inProgress();
        case OrderAdminActionTypes.ORDER_RESUBMIT_SUCCESS:
            return success(null);
        case OrderAdminActionTypes.ORDER_RESUBMIT_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}

export type AdminPushUpdatedFormToOrderState = RemoteData<null, ErrorWrapper>;

export function adminPushUpdatedFormToOrderReducer(
    state: AdminPushUpdatedFormToOrderState = notAsked(),
    action: OrderAdminActions
): AdminPushUpdatedFormToOrderState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_PUSH_UPDATED_FORM:
            return inProgress();
        case OrderAdminActionTypes.ORDER_PUSH_UPDATED_FORM_SUCCESS:
            return success(null);
        case OrderAdminActionTypes.ORDER_PUSH_UPDATED_FORM_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}

export type AdminReplaceFormOnOrderState = RemoteData<null, ErrorWrapper>;

export function adminReplaceFormOnOrderReducer(
    state: AdminReplaceFormOnOrderState = notAsked(),
    action: OrderAdminActions
): AdminReplaceFormOnOrderState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_REPLACE_FORM:
            return inProgress();
        case OrderAdminActionTypes.ORDER_REPLACE_FORM_SUCCESS:
            return success(null);
        case OrderAdminActionTypes.ORDER_REPLACE_FORM_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}

export type AdminMoveOrderBackInWorkflowState = RemoteData<null, ErrorWrapper>;

export function adminMoveOrderBackInWorkflowReducer(
    state: AdminMoveOrderBackInWorkflowState = notAsked(),
    action: OrderAdminActions
): AdminMoveOrderBackInWorkflowState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_MOVE_BACK_IN_WORKFLOW:
            return inProgress();
        case OrderAdminActionTypes.ORDER_MOVE_BACK_IN_WORKFLOW_SUCCESS:
            return success(null);
        case OrderAdminActionTypes.ORDER_MOVE_BACK_IN_WORKFLOW_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}

export type AdminMoveOrderForwardInWorkflowState = RemoteData<null, ErrorWrapper>;

export function adminMoveOrderForwardInWorkflowReducer(
    state: AdminMoveOrderForwardInWorkflowState = notAsked(),
    action: OrderAdminActions
): AdminMoveOrderForwardInWorkflowState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_MOVE_FORWARD_IN_WORKFLOW:
            return inProgress();
        case OrderAdminActionTypes.ORDER_MOVE_FORWARD_IN_WORKFLOW_SUCCESS:
            return success(null);
        case OrderAdminActionTypes.ORDER_MOVE_FORWARD_IN_WORKFLOW_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}

export type AdminAddBlindCarbonCopyToEnvelopeState = RemoteData<null, ErrorWrapper>;

export function adminAddBlindCarbonCopyToEnvelopeReducer(
    state: AdminAddBlindCarbonCopyToEnvelopeState = notAsked(),
    action: OrderAdminActions
): AdminAddBlindCarbonCopyToEnvelopeState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_ADD_BLIND_CARBON_COPY_TO_ENVELOPE:
            return inProgress();
        case OrderAdminActionTypes.ORDER_ADD_BLIND_CARBON_COPY_TO_ENVELOPE_SUCCESS:
            return success(null);
        case OrderAdminActionTypes.ORDER_ADD_BLIND_CARBON_COPY_TO_ENVELOPE_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}

export type AdminUpdateProductProfileDataState = RemoteData<null, ErrorWrapper>;

export function adminUpdateProductProfileDataReducer(
    state: AdminUpdateProductProfileDataState = notAsked(),
    action: OrderAdminActions
): AdminUpdateProductProfileDataState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_UPDATE_PRODUCT_PROFILE_DATA:
            return inProgress();
        case OrderAdminActionTypes.ORDER_UPDATE_PRODUCT_PROFILE_DATA_SUCCESS:
            return success(null);
        case OrderAdminActionTypes.ORDER_UPDATE_PRODUCT_PROFILE_DATA_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}

export type AdminLoadIfgGatewayFilesState = RemoteData<IfgGatewayIntegrationFile[], ErrorWrapper>;

export function adminLoadIfgGatewayFilesReducer(
    state: AdminLoadIfgGatewayFilesState = notAsked(),
    action: OrderAdminActions
): AdminLoadIfgGatewayFilesState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_LOAD_IFG_GATEWAY_FILES:
            return inProgress();
        case OrderAdminActionTypes.ORDER_LOAD_IFG_GATEWAY_FILES_SUCCESS:
            return success(action.payload);
        case OrderAdminActionTypes.ORDER_LOAD_IFG_GATEWAY_FILES_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}

export type AdminResubmitFileToIfgGatewayState = RemoteData<
    IfgGatewayIntegrationFile[],
    ErrorWrapper
>;

export function adminResubmitFileToIfgGatewayReducer(
    state: AdminResubmitFileToIfgGatewayState = notAsked(),
    action: OrderAdminActions
): AdminResubmitFileToIfgGatewayState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_RESUBMIT_FILE_TO_IFG_GATEWAY:
            return inProgress();
        case OrderAdminActionTypes.ORDER_RESUBMIT_FILE_TO_IFG_GATEWAY_SUCCESS:
            return success(action.payload);
        case OrderAdminActionTypes.ORDER_RESUBMIT_FILE_TO_IFG_GATEWAY_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}

export type AdminLoadOrderQueueOptionsState = RemoteData<OrderQueueOptions, ErrorWrapper>;

export function adminLoadOrderQueueOptionsReducer(
    state: AdminLoadOrderQueueOptionsState = notAsked(),
    action: OrderAdminActions
): AdminLoadOrderQueueOptionsState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_LOAD_QUEUE_OPTIONS:
            return inProgress();
        case OrderAdminActionTypes.ORDER_LOAD_QUEUE_OPTIONS_SUCCESS:
            return success(action.payload);
        case OrderAdminActionTypes.ORDER_LOAD_QUEUE_OPTIONS_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}

export type AdminMoveOrderQueueState = RemoteData<null, ErrorWrapper>;

export function adminMoveOrderQueueReducer(
    state: AdminMoveOrderQueueState = notAsked(),
    action: OrderAdminActions
): AdminMoveOrderQueueState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_MOVE_QUEUE:
            return inProgress();
        case OrderAdminActionTypes.ORDER_MOVE_QUEUE_SUCCESS:
            return success(null);
        case OrderAdminActionTypes.ORDER_MOVE_QUEUE_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}

export type AdminUpdateEnvelopeRecipientsState = RemoteData<null, ErrorWrapper>;

export function adminUpdateEnvelopeRecipientsReducer(
    state: AdminUpdateEnvelopeRecipientsState = notAsked(),
    action: OrderAdminActions
): AdminUpdateEnvelopeRecipientsState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_UPDATE_ENVELOPE_RECIPIENTS:
            return inProgress();
        case OrderAdminActionTypes.ORDER_UPDATE_ENVELOPE_RECIPIENTS_SUCCESS:
            return success(null);
        case OrderAdminActionTypes.ORDER_UPDATE_ENVELOPE_RECIPIENTS_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}

export type AdminResubmitOrderToIfgGatewayState = RemoteData<null, ErrorWrapper>;

export function adminResubmitOrderToIfgGatewayReducer(
    state: AdminResubmitOrderToIfgGatewayState = notAsked(),
    action: OrderAdminActions
): AdminResubmitOrderToIfgGatewayState {
    switch (action.type) {
        case OrderAdminActionTypes.ORDER_RESUBMIT_ORDER_TO_IFG_GATEWAY:
            return inProgress();
        case OrderAdminActionTypes.ORDER_RESUBMIT_ORDER_TO_IFG_GATEWAY_SUCCESS:
            return success(null);
        case OrderAdminActionTypes.ORDER_RESUBMIT_ORDER_TO_IFG_GATEWAY_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
}
